import { render } from "./FairMines.vue?vue&type=template&id=036208f0&scoped=true"
import script from "./FairMines.vue?vue&type=script&lang=js"
export * from "./FairMines.vue?vue&type=script&lang=js"

import "./FairMines.vue?vue&type=style&index=0&id=036208f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036208f0"]])

export default __exports__